<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['hotels.menu'])">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h5 class="title-secondary">
        {{ 'HOTELS.HOTELS_LIST.TITLE' | translate }}
      </h5>
    </div>
    <div class="d-flex align-items-end" [formGroup]="form">
      <div>
        <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
          {{ 'CLEAR_FILTERS' | translate }}
        </button>
      </div>

      <div>
        <button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              []
            )
          "
          type="button"
          class="btn btn-success btn-input me-3 btn-export-emails"
          (click)="exportEmails()"
        >
          {{ 'HOTELS.HOTELS_LIST.EXPORT_EMAILS' | translate }}
        </button>
      </div>
      <form
        [formGroup]="form"
        style="display: flex; align-items: flex-end"
        (ngSubmit)="loadData(state, form.get('venue_id').value, form.get('keywords').value)"
      >
        <div>
          <label>{{ 'CLIENTS.CLIENTS_LIST.KEYWORD' | translate }}</label>
          <input type="text" class="form-control input-filter-keywords" [parentFormGroup]="form" [formControlName]="'keywords'" />
        </div>

        <div class="additional-filter-holder relative">
          <label>{{ 'HOTELS.HOTELS_LIST.VENUE' | translate }}</label>
          <app-venue-select [parentFormGroup]="form" [passFormControlName]="'venue_id'"></app-venue-select>
        </div>
        <div>
          <button type="submit" class="btn btn-success btn-input">
            {{ 'HOTELS.HOTELS_LIST.SEARCH' | translate }}
          </button>
        </div>
      </form>

      <div class="ms-3">
        <button type="button" class="btn btn-warning btn-input" (click)="showOnMap()">
          {{ 'HOTELS.HOTELS_LIST.SHOW_MAP' | translate }}
        </button>

        <button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotels.store']
            )
          "
          type="button"
          class="btn btn-secondary btn-input"
          (click)="add()"
        >
          {{ 'HOTELS.HOTELS_LIST.ADD' | translate }}
        </button>
      </div>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="hotelsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event, form.get('venue_id').value, form.get('keywords').value)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    [selectable]="selectableSettings"
    [kendoGridSelectBy]="'id'"
    [selectedKeys]="selectedHotels"
    (selectionChange)="onSelectionChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Hotels', grid, 2)"
  >
    <kendo-grid-checkbox-column [width]="70" showSelectAll="true" class="text-center"></kendo-grid-checkbox-column>

    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'HOTELS.HOTELS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'HOTELS.HOTELS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="120"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'HOTELS.HOTELS_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
      [width]="350"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a [routerLink]="['/hotels/view']" [queryParams]="{ id: dataItem.id }" target="_blank">
          {{ dataItem.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="stars"
      title="{{ 'HOTELS.HOTELS_LIST.STARS' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('stars')"
      width="65"
      [columnMenu]="false"
      format="0"
    ></kendo-grid-column>

    <kendo-grid-column
      field="venue.distance"
      [filterable]="apiQuery.hasFilter('venue_id')"
      [sortable]="apiQuery.hasFilter('venue_id')"
      title="{{ 'HOTELS.HOTELS_LIST.KM_TO_FAIR' | translate }}"
      [hidden]="isHiddenColumn('distance_to_fair')"
      [width]="100"
      [columnMenu]="apiQuery.hasFilter('venue_id')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false" operator="lte">
        </kendo-grid-numeric-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.venue?.distance }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="city.country.name"
      title="{{ 'HOTELS.HOTELS_LIST.COUNTRY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('city.country.name', true)"
      width="120"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-country-select [filter]="filter" [field]="'city.country_id'"></app-kendo-country-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-country-box [country]="dataItem?.city?.country"></app-country-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="city.name"
      title="{{ 'HOTELS.HOTELS_LIST.CITY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('city.name')"
      width="120"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-city-select [filter]="filter"></app-kendo-city-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="address"
      title="{{ 'HOTELS.HOTELS_LIST.ADDRESS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('address')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="distance_to_center"
      title="{{ 'HOTELS.HOTELS_LIST.DISTANCE_TO_CENTER' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('distance_to_center')"
      [width]="100"
      [columnMenu]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false" operator="lte">
        </kendo-grid-numeric-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="distance_to_airport"
      title="{{ 'HOTELS.HOTELS_LIST.DISTANCE_TO_AIRPORT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('distance_to_airport', true)"
      [width]="100"
      [columnMenu]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false" operator="lte">
        </kendo-grid-numeric-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="distance_to_tr_point"
      title="{{ 'HOTELS.HOTELS_LIST.DISTANCE_TO_TR_POINT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('distance_to_tr_point', true)"
      [width]="100"
      [columnMenu]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false" operator="lte">
        </kendo-grid-numeric-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="distance_to_tr_point_name"
      title="{{ 'HOTELS.HOTELS_LIST.DISTANCE_TO_TR_POINT_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('distance_to_tr_point_name', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="type.value"
      title="{{ 'HOTELS.HOTELS_LIST.TYPE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('type.value', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'hotels'" [filter]="filter"></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="rooms_count"
      title="{{ 'HOTELS.HOTELS_LIST.ROOMS' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('rooms_count', true)"
      width="80"
      format="0"
    ></kendo-grid-column>

    <kendo-grid-column
      field="contacts"
      title="{{ 'HOTELS.HOTELS_LIST.CONTACTS' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('contacts')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngFor="let contact of dataItem.contacts; let i = index">
          <span class="contact-key">{{ contact?.type?.value }}:</span>
          <span class="contact-value">{{ contact?.value }} <span *ngIf="contact?.note">({{ contact?.note }})</span></span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="tags"
      title="{{ 'HOTELS.HOTELS_LIST.TAGS' | translate }}"
      filter="text"
      [sortable]="false"
      [hidden]="isHiddenColumn('tags', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <app-kendo-tag-select [filter]="filter" [model]="LaravelModels.HOTEL"></app-kendo-tag-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span *ngFor="let tag of dataItem?.tags; let i = index">
          {{ tag }}<span *ngIf="i !== dataItem?.tags?.length - 1">, </span>
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="isHiddenColumn('created_at', true)"
      field="created_at"
      title="{{ 'HOTELS.HOTELS_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="show_to_web"
      title="{{ 'HOTELS.HOTELS_LIST.SHOW_TO_WEB' | translate }}"
      filter="boolean"
      [width]="130"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('show_to_web', true)"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.show_to_web"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'HOTELS.HOTELS_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="130"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active', true)"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTELS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-preview-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING,
                UserRoleType.EXTERNAL_PARTNER_LEAD,
                UserRoleType.EXTERNAL_PARTNER
              ],
              ['hotels.show']
            )
          "
          [link]="['/hotels/view']"
          [params]="{ id: dataItem.id }"
        >
        </app-preview-button>

        <app-edit-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              ['hotels.show']
            )
          "
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-seo-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['hotels.translations'])"
          (click)="editSeo(dataItem)"
        ></app-seo-button>

        <app-delete-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotels.destroy']
            )
          "
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>

        <app-phone-calls-finder-button [id]="dataItem.id" [type]="LaravelModels.HOTEL">
        </app-phone-calls-finder-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'HOTELS.HOTELS_LIST.UPLOAD_IMAGES' | translate"
          container="body"
          [collectionName]="'gallery'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.HOTEL"
        >
        </app-media-library-button>
        <!--        <app-media-library-button-->
        <!--          [ngbTooltip]="'HOTELS.HOTELS_LIST.UPLOAD_DOCUMENTS' | translate"-->
        <!--          container="body"-->
        <!--          [modelId]="dataItem.id"-->
        <!--          [modelType]="LaravelModels.HOTEL"-->
        <!--          [collectionName]="'invoices'"-->
        <!--          [acceptType]="MediaLibraryAcceptTypes.ALL"-->
        <!--          [icon]="'fal fa-file'"-->
        <!--        ></app-media-library-button>-->
        <app-activities-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              []
            )
          "
          [subjectType]="LaravelModels.HOTEL"
          [subjectId]="dataItem.id"
        >
        </app-activities-button>

        <app-links-compact-translates
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              []
            )
          "
          [data]="dataItem"
        >
        </app-links-compact-translates>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button
        (click)="loadData(state, form.get('venue_id').value, form.get('keywords').value)"
      ></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
